// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_um-0";
export var checkoutRateBadgeLink = "_um-1";